import { useErrorHandlerContext } from '@/customHooks';
import { useInventoryInspection } from '@/inventoryApi';
import { navigateTo, Paths } from '@/router';
import { InventoryForm } from '@/components/organism';
import { LoadingSpinner } from '@/components/atoms';

const PageContent = () => {
  const { open: errorHandle } = useErrorHandlerContext();

  const params = new URLSearchParams(window.location.search);
  const propertyId = params.get('propertyId');
  const inspectionId = params.get('inspectionId');
  const isReadOnly = params.get('readonly') === 'true';

  const {
    data: inspectionData,
    loading: isLoadingInspection,
    error: inspectionError,
    refetch: refetchInspection,
  } = useInventoryInspection(propertyId ?? '', inspectionId ?? '', {
    onError: errorHandle,
  });

  if (!propertyId) {
    return (
      <div className="container mx-auto px-4 py-8">
        <p className="text-lg font-semibold text-gray-700">
          Se requiere un ID de propiedad para crear un inventario
        </p>
      </div>
    );
  }

  const handleClose = () => {
    navigateTo(`${Paths.INVENTORY}${Paths.LIST}?propertyId=${propertyId}`);
  };

  if (inspectionId && isLoadingInspection) {
    return (
      <div className="container mx-auto px-4 py-8">
        <LoadingSpinner />
      </div>
    );
  }

  if (inspectionId && inspectionError) {
    return (
      <div className="container mx-auto px-4 py-8 text-center">
        <p className="font-semibold text-red-700">{inspectionError.message}</p>
        <button
          type="button"
          onClick={() => void refetchInspection()}
          className="mt-4 rounded-lg bg-primary1 px-4 py-2 text-sm font-semibold text-white"
        >
          Reintentar
        </button>
      </div>
    );
  }

  const isEditMode = Boolean(inspectionId && inspectionData);

  return (
    <div className="container mx-auto px-4 py-8">
      <InventoryForm
        key={inspectionId ?? 'create'}
        mode={isEditMode ? 'edit' : 'create'}
        propertyId={propertyId}
        inventory={inspectionData ?? null}
        isReadOnly={isReadOnly}
        onClose={handleClose}
      />
    </div>
  );
};

export const InventoryFormPage = () => {
  return <PageContent />;
};
